const React = require('react');

const {DEFAULT_CURRENCY} = require('../../../../../../../../constants/currencies');
const withState = require('../../../../../../../../utils/withState');
const {apiAdminRetailerFlowGet, apiAdminRetailerFlowUpdate} = require("../../../../../../../../api/admin/retailers");
const {TrxProcessingForm} = require("../../../../../../../dumb/AdminHelpers/AdminConfigs");
const {PAYMENT_METHODS} = require("../../../../../../../../constants/paymentMethods");

module.exports = withState((setState, self, onMount) => {
  const id = 'ffffffff-ffff-ffff-ffff-ffffffffffff';

  self.state = {
    ...self.state,
    loading: true
  }

  onMount(() => {
    apiAdminRetailerFlowGet({merchant_id: id}).then((retailerGateway) => {
      const retailerGateways = {};

      (retailerGateway.list || []).forEach((el) => {
        retailerGateways[el.payment_method] = el.payment_gateway;
      });

      setState({
        data: {
          ...retailerGateways,
          fiat_code: DEFAULT_CURRENCY,
        },
        loading: false
      })
    })
  })

  const onSubmit = ({fiat_code, confirmBearer, ...payload}) => apiAdminRetailerFlowUpdate({merchant_id: id, payload, confirmBearer});

  return ({loading, data, initialErrors}) => {
    return loading
      ? <span />
      : (
        <TrxProcessingForm
          data={data}
          onSubmit={onSubmit}
          initialErrors={initialErrors}
          disabledCurrencySelect
        />
      )
  }
})
